import axiosClient from "../api/axiosClient";

export const login = async (phoneNumber, password) => {
  const response = await axiosClient.post("/auth/login", { phoneNumber, password });
  return response.data;  // expected: { accessToken, refreshToken }
};

export const logout = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
};
